exports = module.exports = require("/code/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".editor-Canvas{position:relative;min-height:100vh;margin-left:23rem;padding-bottom:1px;background-color:#e8e8e8}.editor-Canvas-sections{padding:3.5rem 2rem}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** /code/~/css-loader?-minimize!/code/~/postcss-loader!/code/~/less-loader!./editor/Canvas.less
 ** module id = 891
 ** module chunks = 1
 **/